<template>
  <v-dialog v-model="dialog" max-width="510">
    <v-card>
      <v-card-title class="text-h3">
        {{ $t('STEPPER_RESET_DIALOG_TITLE') }}
      </v-card-title>

      <v-card-text class="text-body-2">
        {{ $t('STEPPER_RESET_DIALOG_DESC') }}
      </v-card-text>

      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn tile outlined class="non-text-transformation link" @click="handleCancel">
          {{ $t('STEPPER_RESET_DIALOG_BUTTON_CANCEL') }}
        </v-btn>

        <v-btn
          tile
          class="ml-4 non-text-transformation link"
          color="primary"
          @click="handleConfirm"
        >
          {{ $t('STEPPER_RESET_DIALOG_BUTTON_CONFIRM') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResetOfferDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set() {
        // HACK: avoid component directly mutating prop `show` on click outside
        this.handleCancel()
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancelResetOffer')
    },
    handleConfirm() {
      this.$emit('confirmResetOffer')
    },
  },
}
</script>
